/* eslint-disable */
export const slugify = (string) => {
	const a = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
	const b = 'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------'
	const p = new RegExp(a.split('').join('|'), 'g')

	return (
		string.toString().toLowerCase()
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
			.replace(/&/g, '-and-') // Replace & with 'and'
			// eslint-disable-next-line no-useless-escape
			.replace(/[^\w\-]+/g, '') // Remove all non-word characters
			// eslint-disable-next-line no-useless-escape
			.replace(/\-\-+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, '') // Trim - from end of text
	)
}

export const getCookie = cName => {
	const cookieName = `${cName}=`;
	const allCookies = document.cookie.split(';');
	for (let i = 0; i < allCookies.length; i++) {
		let c = allCookies[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(cookieName) === 0) {
			return c.substring(cookieName.length, c.length);
		}
	}
	return '';
}

export const setCookie = (cName, cValue, expdays) => {
	let dotDomain = '';
	const domainParts = window.location.hostname.split('.');
	if (domainParts.length > 2) {
		dotDomain += '.' + domainParts.slice(-2).join('.');
	} else {
		dotDomain = window.location.hostname;
	}
	const date = new Date();
	date.setTime(date.getTime() + (expdays * 24 * 60 * 60 * 1000));
	const expires = `expires=${date.toUTCString()}`;
	document.cookie = `${cName}=${cValue};${expires};path=/;domain=${dotDomain}`;
}

/**
* Validates an email string.
*/
export const validateEmailFormat = (email) => {
    if (!email) {
        return false;
    }
    // check if email is a string or a node.
    const emailString = typeof email === 'string' ? email : email.value;
    // eslint-disable-next-line no-useless-escape
	const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return emailRegex.test(emailString);
}
